import { apolloClient } from 'common/graphql/clients';

import { EP_AGREEMENT_WALL_STEPS_STORAGE_KEY } from '../pages/Hub/helpers/getSteps';

const actions = {
  clearStoredSteps: () => {
    sessionStorage.removeItem(EP_AGREEMENT_WALL_STEPS_STORAGE_KEY);
  },
  /**
   * Refetch the query conditioning the display of the EpAgreementWall flow,
   * to get the latest `shouldAskForEpCguAgreement` value,
   * which should be false at the end of the flow,
   * so the user can access the rest of the app again.
   */
  refetchLoggedInRoutesAccess: async () => {
    // Here we should use client.refetchQueries to re-fetch `getLoggedInRoutesAccessQuery` specifically,
    // but it’s only available in Apollo Client 3.4.x
    await apolloClient.reFetchObservableQueries();
  },
};

export default actions;
